@if (isOpen()) {
  <div class="apps-panel-overlay" (click)="onBackdropClick()">
    <div class="apps-panel-backdrop"></div>
    <div class="apps-panel-container" (click)="onPanelClick($event)">
      <div class="apps-panel-header">
        <h6 class="f-s-16 f-w-600 m-0">Applications</h6>
      </div>
      <app-apps-grid (clickOnTile)="closePanel.emit()"></app-apps-grid>
    </div>
  </div>
}